import { SegmentedControl } from "./SegmentedControl";
import { useUnits } from "../../context/UnitsProvider";
import type { DistanceUnit } from "../../lib/units";

const UNIT_OPTIONS: ReadonlyArray<{ value: DistanceUnit; label: string }> = [
  { value: "mi", label: "Miles" },
  { value: "km", label: "Km" }
];

const COMPACT_UNIT_OPTIONS: ReadonlyArray<{ value: DistanceUnit; label: string }> = [
  { value: "mi", label: "mi" },
  { value: "km", label: "km" }
];

/**
 * Miles/km display-unit toggle, bound to the app-wide `UnitsProvider`. Pure
 * client-side preference — flipping it re-renders every distance/pace/elevation
 * surface in the user's chosen unit without touching stored data. Reused in the
 * Preferences modal and the My Training header.
 */
export function UnitToggle({
  fill = false,
  compact = false,
  ariaLabel = "Measurement units"
}: {
  fill?: boolean;
  /** Smaller mi/km pill for inline form labels. */
  compact?: boolean;
  ariaLabel?: string;
}) {
  const { distanceUnit, setDistanceUnit } = useUnits();
  return (
    <div className={compact ? "fgx-unit-toggle--compact" : undefined}>
      <SegmentedControl
        options={compact ? COMPACT_UNIT_OPTIONS : UNIT_OPTIONS}
        value={distanceUnit}
        onChange={setDistanceUnit}
        fill={fill}
        variant={compact ? "outline" : "pill"}
        ariaLabel={ariaLabel}
      />
    </div>
  );
}
